<template>
    <div>
        <!-- RECEBIMENTO DE LISTA -->
        <v-row>
            <!-- SELECIONAR CODPERLET -->
            <v-col cols="12" sm="12" class="px-2" v-if="!selectedAluno.ra">
                <PletivoVigente @on-select-perlet="onSelectPerlet" />
            </v-col>
                
            <!-- FILTRAR ALUNO -->
            <v-col cols="12" sm="12" v-if="periodo_letivo">
                <v-text-field v-model="search" clearable
                    placeholder="RA, nome do aluno ou responsável..."
                    :disabled="$store.state.checklistdb.loading_id == 'get-alunos'"
                    :loading="$store.state.checklistdb.loading_id == 'get-alunos'"
                    v-show="!(!!selectedAluno && !!selectedAluno.ra)"
                    messages="Um aluno pode ser encontrado pelo RA, Nome ou Nome do Responsável(acadêmico ou financeiro). ENTER para pesquisar..."
                    @keypress.enter="pesquisarAluno"
                >
                    <template v-slot:append>
                        <v-btn @click.prevent="pesquisarAluno" :disabled="!search">Pesquisar</v-btn>
                    </template>
                </v-text-field>
            </v-col>
            <v-col cols="12" sm="12">
                <!-- Lista de alunos pesquisados -->
                <loading-gdb :propObject="$store.state.checklistdb.aluno_imagem_loading"
                    text="Pesquisando alunos..." />
                <span v-for="a, i in computedAlunos" :key="i" class="my-1" v-show="!(selectedAluno && selectedAluno.ra) && !!periodo_letivo">
                    <ItemAlunoPesquisa :item="a" @on-click-item="selecionarAluno(a)"
                        :loading="[`get-aluno-imagem-${a.codpessoa}`, `get-aluno-listas-${a.ra}`].includes($store.state.checklistdb.loading_id)"/>
                </span>
                <!-- Aluno Pesquisado quando Selecionado -->
                <span>
                    <ItemAlunoSelecionado
                        :item="selectedAluno"
                        v-if="!!selectedAluno && !!selectedAluno.ra"
                        @on-close="desselecionarAluno()"
                        />
                </span>
            </v-col>
            <v-col cols="12" v-show="computedLists.length > 0">
                <v-list dense>
                    <v-list-item v-for="item, index in computedLists" :key="index">
                        <v-list-item-title>{{item.descricao}}</v-list-item-title>
                        <v-list-item-subtitle>{{item.codperlet}}</v-list-item-subtitle>
                    </v-list-item>
                </v-list>
            </v-col>
        </v-row>
        <helper-gdb text="Aluno" v-if="$store.getters.StateAuthenticatedUser.is_superuser"/>
    </div>
</template>
<script>
import {mapActions} from 'vuex'
import ItemAlunoPesquisa from './ItemAlunoPesquisa.vue'
import ItemAlunoSelecionado from './ItemAlunoSelecionado.vue'
import PletivoVigente from './PletivoVigente.vue'
export default {
    name: 'CheckListDBAluno',
    components: {
        ItemAlunoPesquisa, ItemAlunoSelecionado, PletivoVigente
    },
    data: () => ({
        search: null,
        selectedAluno: {},
        periodo_letivo: null,
    }),
    methods: {
        ...mapActions([
                // 'GetCheckListSettings',
                'GetCheckListAlunos',
                'GetCheckLists',
                'GetCheckListAlunoImagem',
                'GetCheckListAlunoListas']),
        onSelectPerlet(value){
            this.periodo_letivo = value
            if(this.search){
                this.pesquisarAluno()
            }
        },
        pesquisarAluno(){
            this.GetCheckListAlunos({ q: this.search, perlet: this.periodo_letivo })
        },
        // onChangePletivo(value){
        //     this.GetCheckLists({ codperlet: value.codperlet })
        // },
        async selecionarAluno(aluno){
            const alu = aluno
            const imagem = await this.GetCheckListAlunoImagem({codpessoa: aluno.codpessoa})
            const listas = await this.GetCheckListAlunoListas({
                                                                ra: aluno.ra,
                                                                codperlet: aluno.codperlet,
                                                                page_size: 15
                                                                })
            this.selectedAluno = Object.assign({}, {...alu, imagem, listas})
        },
        desselecionarAluno(){
            this.selectedAluno = Object.assign({}, {})
        },
    },
    mounted(){
        //this.GetCheckListSettings()
    },
    computed: {
        computedAlunos() {
            const alunos = this.$store.state.checklistdb.alunos
            return alunos
        },
        computedLists() {
            const rs = [].filter(o => o.codperlet == (this.selectedAluno||{}).codperlet)
            return rs
        }
    }
}
</script>